import { LayoutWithSidebar } from 'utils/router/components/LayoutWithSidebar/LayoutWithSidebar'

export const PerformanceAnalyticsRoutes = [
  {
    path: 'analytics',
    Component: LayoutWithSidebar,
    alias: 'analytics',
    children: [
      {
        index: true,
        lazy: () => import('../pages/PerformanceAnalytics'),
      },
    ],
  },
] as const
